import React, {useEffect, useState} from "react"
import "./MovieList.css"
import { useParams } from "react-router-dom"
import Cards from "../card/Card"
import background from "../../assets/wall.jpg"

const MovieList = () => {
    
    const [movieList, setMovieList] = useState([])
    const {type} = useParams()

    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        getData()
    }, [type])
    const API_KEY = process.env.REACT_APP_TMDB_API_KEY;
    const getData = () => {
        fetch(`https://api.themoviedb.org/3/movie/${type}?api_key=${API_KEY}`)
        .then(res => res.json())
        .then(data => setMovieList(data.results))
    }

    return (
        <div className="wall" style={{ backgroundImage: `url(${background})` }}>
        <div className="movieList" >
            <div className="Movies">
                {
                    movieList.slice(0,12).map(movie => (
                        <Cards movie={movie} />
                    ))
                }
            </div>
        </div>
        </div>
    )
}

export default MovieList;